









































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import Api from '@/api/marketing/live/index'
import CustomForm from '../../../components/custom-form/index.vue'

@Component({
  components: {
    PicModal,
    CustomForm,
  },
})
export default class EditArticleCategory extends AbpBase {
  couponModal: boolean = false
  couponsData: any[] = []
  selecCoupon: any = {}
  pageShops = {
    totalCount: 0,
    currentPage: 1,
    maxResultCount: 10,
  }
  filtersModal = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'keyWord',
    },
  ]
  columnsCoupons: any[] = [
    {
      title: '优惠券名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '优惠券类型',
      key: 'couponTypeDisplayName',
      align: 'center',
    },
    {
      title: '有效期',
      key: 'validDate',
      align: 'center',
    },
    {
      title: '是否已审核',
      slot: 'published',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]
  form = {
    name: null,
    coverImgUrl: null,
    price: null,
  }
  id: any = null
  ruleForm = {
    coverImgUrl: [{ required: true, message: '请选择优惠券图片', trigger: 'blur' }],
    name: [{ required: true, message: '请输入优惠券名称', trigger: 'blur' }],
    // price: [{ required: true, message: "请输入优惠券价格", trigger: "blur" }],
  }
  created() {
    this.getCategory()
  }

  /**
   * 根据id获取直播间商品信息
   */
  getCategory() {
    let id = this.$route.query['id']

    if (id) {
      this.id = id
      Api.getLiveGoodsInfoById(id.toString()).then((res) => {
        console.log(res)
        this.form = res.data
        this.form.price = res.data.price
        this.selecCoupon.id = res.data.couponId
        this.selecCoupon.name = res.data.couponName
        this.selecCoupon.externId = res.data.externId
        this.selecCoupon.code = res.data.code
      })
    }
  }

  openCouponModal() {
    this.getCouponsList()
    this.couponModal = true
  }
  picChange(e) {
    this.form.coverImgUrl = e[0].url
  }
  submitModalChange(form, valid) {
    if (valid) {
      this.getCouponsList(form)
    }
  }
  getCouponsList(form = {}) {
    let keyWord = form['keyWord']
    let { maxResultCount, currentPage } = this.pageShops
    Api.getCouponList(maxResultCount, currentPage, keyWord)
      .then((res) => {
        let { totalCount, items } = res.data
        this.pageShops.totalCount = totalCount
        this.couponsData = items
      })
      .catch(() => {
        this.pageShops.totalCount = 0
        this.couponsData = []
      })
  }
  // TODO
  submit() {
    let vm = this
    let form: any = vm.$refs.form
    console.log('数据')
    if (this.selecCoupon.id == undefined) {
      this.$Notice.warning({ desc: '请选择优惠券' })
      return
    }
    if (vm.form.price == null || vm.form.price <= 0) {
      this.$Notice.warning({ desc: '请选择优惠券价格不能低于0.01元' })
      return
    }
    console.log(this.selecCoupon)
    let model: any = {
      name: vm.form.name,
      code: this.selecCoupon.code,
      priceType: 1,
      coverImgUrl: vm.form.coverImgUrl,
      price: vm.form.price,
      productId: this.selecCoupon.id,
      couponId: this.selecCoupon.id,
      couponName: this.selecCoupon.name,
      aditSatus: -1,
      externId: this.selecCoupon.externId,
    }
    console.log(model)
    form.validate((valid) => {
      if (valid) {
        if (this.id) {
          Api.updatedGoodsInfoById(this.id, model).then((res) => {
            this.$Notice.success({ desc: '提交成功' })
            vm.$router.push({
              name: 'liveRoomCommodity',
            })
          })
        } else {
          let arr = []
          arr.push(model)
          Api.selectGoodsByMyGoodsList(arr).then((res) => {
            this.$Notice.success({ desc: '提交成功' })
            vm.$router.push({
              name: 'liveRoomCommodity',
            })
          })
        }
      }
    })
  }
  selectGoods(row) {
    console.log(row)
    this.couponModal = false
    this.selecCoupon = row
    this.$set(this.selecCoupon, 'name', row.name)
  }
  cancel() {
    this.couponModal = false
  }
  onPageShopsChange(pageIndex) {
    this.pageShops.currentPage = pageIndex
    this.getCouponsList(this.$refs['lineModalForm'])
  }
}
